import { render, staticRenderFns } from "./UrunIcerik.vue?vue&type=template&id=454dd6ff"
import script from "./UrunIcerik.vue?vue&type=script&lang=js"
export * from "./UrunIcerik.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports